import { render, staticRenderFns } from "./legalnotice.vue?vue&type=template&id=663f1b0a&scoped=true&lang=pug&"
var script = {}
import style0 from "./legalnotice.vue?vue&type=style&index=0&id=663f1b0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f1b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663f1b0a')) {
      api.createRecord('663f1b0a', component.options)
    } else {
      api.reload('663f1b0a', component.options)
    }
    module.hot.accept("./legalnotice.vue?vue&type=template&id=663f1b0a&scoped=true&lang=pug&", function () {
      api.rerender('663f1b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/legalnotice.vue"
export default component.exports